window.Repeaters = new function()
{
    this.init = function() {
        jQuery('body').on('click', '.repeater-field .actions .add', function(event) {
            event.preventDefault();

            var max_rows       = 5;
            var repeater_field = jQuery(this).closest('.repeater-field');
            var num_rows       = jQuery(repeater_field).find('.field').length;

            if(jQuery(repeater_field).attr('data-existing-repeater')) {
                var existing_repeater = jQuery(repeater_field).attr('data-existing-repeater');
                var existing_rows     = jQuery(existing_repeater).find('.field').length;
                num_rows += existing_rows;
            }

            if(jQuery(repeater_field).attr('data-max-rows')) {
                max_rows = jQuery(repeater_field).attr('data-max-rows');
            }

            if(num_rows < max_rows) {
                Repeaters.addRow(this);
            }

            if(jQuery(this).closest('.repeater-field').find('.fields').attr('id') == 'repeaterImages2') {
                jQuery('.new-images-notice').removeClass('hidden');
            }

            jQuery(this).closest('.repeater-field').addClass('show-row-move');
        });

        jQuery('body').on('click', '.repeater-field .row-actions .remove', function(event) {
            event.preventDefault();
            Repeaters.removeRow(this);
        });

        jQuery('body').on('click', '.repeater-field .row-actions .up', function(event) {
            event.preventDefault();
            Repeaters.moveUpRow(this);
        });

        jQuery('body').on('click', '.repeater-field .row-actions .down', function(event) {
            event.preventDefault();
            Repeaters.moveDownRow(this);
        });

        if(!jQuery('body').hasClass('create_edit_page')) {
            Repeaters.initSortable();
        }

        //Repeater images preview thumbnail
        jQuery('body').on('change', '.repeater-field input', function(event) {
            var file    = $(this).get(0);
            var preview = window.URL.createObjectURL(file.files[0]);

            jQuery(this).closest('.field').find('.img-container').remove();
            $(this).after('<div class="img-container"><img src="' + preview + '" /></div>');
            jQuery(this).closest('.field').show();
        });
    };

    /**
     * Initialize drag and drop library
     */
    this.initSortable = function() {
        if(jQuery('#repeaterList:not(.initialized)').length > 0) {
            Sortable.create(repeaterList, {
                group:'repeaterList',
                handle: '.row-move',
                animation: 150
            });

            jQuery('#repeaterList').addClass('initialized');
        }

        if(jQuery('.multi-repeater:not(.initialized)').length > 0 ) {
            jQuery('.multi-repeater:not(.initialized)').each(function(index, el) {
                Sortable.create(el, {
                    handle: '.row-move',
                    animation: 150
                });
            });

            jQuery('.multi-repeater').addClass('initialized');
        }

        if(jQuery('#repeaterImages:not(.initialized)').length > 0) {
            Sortable.create(repeaterImages, {
                group:'repeaterImages',
                handle: '.row-move',
                animation: 150
            });

            jQuery('#repeaterImages').addClass('initialized');
        }

        if(jQuery('#repeaterImages2:not(.initialized)').length > 0) {
            Sortable.create(repeaterImages2, {
                group:'repeaterImages2',
                handle: '.row-move',
                animation: 150
            });

            jQuery('#repeaterImages2').addClass('initialized');
        }
    };

    /**
     * Initialize drag and drop library for page builder backend
     */
    this.initPageBuilderSortable = function() {
        jQuery('.page-builder-repeater:not(.initialized)').each(function(index, el) {
            Sortable.create(el, {
                handle: '.row-move',
                animation: 150
            });
        });
    };

    /**
     * Add new row to end of repeater
     * Use backup row if data-backup-row is set
     *
     * @param obj el - add row button of repeater group
     */
    this.addRow = function(el) {
        var repeater_field = jQuery(el).closest('.repeater-field');

        if(jQuery(repeater_field).attr('data-backup-row')) {
            var backup_row      = jQuery(repeater_field).attr('data-backup-row');
            var backup_row_html = jQuery('.' + backup_row).html();

            var appended = jQuery(repeater_field).find('.fields').append(backup_row_html);

            if(jQuery(appended).find('.user-autocomplete-backup').length) {
                jQuery(appended).find('.user-autocomplete-backup').removeClass('user-autocomplete-backup').addClass('user-autocomplete');
                UserAutoCompleteV2.init();
            }
        } else {
            jQuery(repeater_field).find('.field:last-child').clone().appendTo(jQuery(repeater_field).find('.fields'));
            jQuery(repeater_field).find('.field:last-child input').val('');
        }

        jQuery(repeater_field).find('.field:last-child input').click();
    };

    /**
     * Delete row from repeater
     *
     * @param obj el - add row button of repeater group
     */
    this.removeRow = function(el) {
        var repeater_field = jQuery(el).closest('.repeater-field');
        jQuery(el).closest('.field').remove();

        try {
            var row_count = jQuery(repeater_field).find('.field').length;
            if(row_count == 0) {
                CreatePostV2.resetPostType();
            }
        } catch(e) { }
    };

    /**
     * Move repeater row up one
     *
     * @param obj el - add row button of repeater group
     */
    this.moveUpRow = function(el) {
        var row = jQuery(el).closest('.field');

        if(jQuery(row).prev('.field').length) {
            jQuery(row).insertBefore(jQuery(row).prev('.field'));
        }
    };

    /**
     * Move repeater row down one
     *
     * @param obj el - add row button of repeater group
     */
    this.moveDownRow = function(el) {
        var row = jQuery(el).closest('.field');

        if(jQuery(row).next('.field').length) {
            jQuery(row).insertAfter(jQuery(row).next('.field'));
        }
    };
}

jQuery(document).ready(function($) {
    Repeaters.init();
});
